import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Grid,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import TutorialCard from "../../components/TutorialCard";
import CustomAppBar from "../../components/AppBar";
import { t } from "i18next";
import api from "../../globals/axios";
import { useTranslation } from "react-i18next";
import { languages } from "../../globals/utils";

const Tutorials = () => {
  const [tutorials, setTutorials] = useState([]);
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n?.language || "en");

  const fetchTutorials = async () => {
    try {
      const response = await api.get(`/common/tutorials?language=${language}`);
      setTutorials(response.data);
    } catch (error) {
      console.log("Error Fetching Tutorials list:", error);
    }
  };

  const handleLanguageChange = (event) => {
    const value = event.target.value;
    setLanguage(value);
  };

  useEffect(() => {
    fetchTutorials();
  }, [language]);

  return (
    <>
      <Helmet>
        <title>Tutorials - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Typography
          sx={{ fontSize: "24px", marginY: "20px", textAlign: "center" }}
        >
          {t("Tutorials")}
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">{t("Language")}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={language}
            label={t("Language")}
            onChange={handleLanguageChange}
          >
            {languages.map((lang) => (
              <MenuItem value={lang.value} key={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          {tutorials.map((tutorial) => (
            <Grid item xs={12} key={tutorial.id}>
              <TutorialCard
                videoUrl={tutorial.url}
                title={tutorial.title}
                description={tutorial.description}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default Tutorials;
